export const EnumNotify = {
  NotifyStatus: {
    All : 0,
    UnRead: 1
  },
  Action: {

    /// <summary>
    /// Sau khi gửi công việc, gửi thông báo cho người phụ trách
    /// </summary>
    TaskGo2_SendTaskToSupervisor: "TaskGo2_SendTaskToSupervisor",

    /// <summary>
    /// Sau khi gửi công việc, gửi thông báo cho người chủ trì
    /// </summary>
    TaskGo2_SendTaskToExecutor : "TaskGo2_SendTaskToExecutor",

    /// <summary>
    /// Sau khi gửi công việc, gửi thông báo cho người phối hợp
    /// </summary>
    TaskGo2_SendTaskToCombination : "TaskGo2_SendTaskToCombination",

    /// <summary>
    /// Sau khi gửi công việc, gửi thông báo cho người liên quan
    /// </summary>
    TaskGo2_SendTaskToPeopleInvolved : "TaskGo2_SendTaskToPeopleInvolved",

    /// <summary>
    /// Cập nhật trường dữ liệu công việc
    /// </summary>
    TaskGo2_UpdateField : "TaskGo2_UpdateField",

    /// <summary>
    /// Có người bình luận vào công việc mà mình là người giao việc
    /// </summary>
    TaskGo2_Comment : "TaskGo2_Comment",

    /// <summary>
    /// Người chủ trì gửi công việc cho mình phê duyệt
    /// </summary>
    TaskGo2_SendApprovalToAssigner : "TaskGo2_SendApprovalToAssigner",

    /// <summary>
    /// Người chủ trì gửi công việc
    /// </summary>
    TaskGo2_SendTaskApproval : "TaskGo2_SendTaskApproval",

    /// <summary>
    /// Người giao việc đã phê duyệt công việc
    /// </summary>
    TaskGo2_ApprovedTask : "TaskGo2_ApprovedTask",

    /// <summary>
    /// Người giao việc đã từ chối công việc
    /// </summary>
    TaskGo2_DeniedTask : "TaskGo2_DeniedTask",

    /// <summary>
    /// Thu hồi đề nghị phê duyệt công việc
    /// </summary>
    TaskGo2_RevokeTask : "TaskGo2_RevokeTask",

    /// <summary>
    /// Chuyển công việc mình là người chủ trì cho người khác
    /// </summary>
    TaskGo2_DeleteMeToExecutor : "TaskGo2_DeleteMeToExecutor",

    /// <summary>
    /// Xóa mình là người phối hợp
    /// </summary>
    TaskGo2_DeleteMeToCombination : "TaskGo2_DeleteMeToCombination",

    /// <summary>
    /// Chuyển công việc mình là người liên quan cho người khác
    /// </summary>
    TaskGo2_DeleteMeToPeopleInvolved : "TaskGo2_DeleteMeToPeopleInvolved",

    /// <summary>
    /// Tạo công việc con
    /// </summary>
    TaskGo2_CreateTaskChild : "TaskGo2_CreateTaskChild",

    /// <summary>
    /// Nhắc đến mình trong một bình luận
    /// </summary>
    TaskGo2_Comment_Mention : "TaskGo2_Comment_Mention",

    /// <summary>
    /// Người giao việc xóa công việc
    /// </summary>
    TaskGo2_AssignerDeleteTask : "TaskGo2_AssignerDeleteTask",

    /// <summary>
    /// Nhắc việc trước khi bắt đầu
    /// </summary>
    TaskGo2_RemindStartTime : "TaskGo2_RemindStartTime",

    /// <summary>
    /// Nhắc việc sau khi bắt đầu
    /// </summary>
    TaskGo2_RemindEndTime : "TaskGo2_RemindEndTime",

    /// <summary>
    /// Nhắc việc sau khi bắt đầu
    /// </summary>
    TaskGo2_Attachment : "TaskGo2_Attachment",

    /// <summary>
    /// Thêm người ủy quyền
    /// </summary>
    TaskGo2_AddAuthorizedPerson : "TaskGo2_AddAuthorizedPerson",

    /// <summary>
    /// Xóa người ủy quyền
    /// </summary>
    TaskGo2_DeleteAuthorizedPerson : "TaskGo2_DeleteAuthorizedPerson",

    
    /// <summary>
    /// Giao công việc thay người giao việc
    /// </summary>
    TaskGo2_SendTaskInsteadAssigner : "TaskGo2_SendTaskInsteadAssigner",

    /// <summary>
    /// Tạo công việc con thay người ủy quyền
    /// </summary>
    TaskGo2_CreateTaskChildInstead : "TaskGo2_CreateTaskChildInstead",

    /// <summary>
    /// Gửi phê duyệt thay người ủy quyền
    /// </summary>
    TaskGo2_SendTaskApprovalInsteadExecutor : "TaskGo2_SendTaskApprovalInsteadExecutor",
    
    /// <summary>
    /// Thu hồi phê duyệt thay người ủy quyền
    /// </summary>
    TaskGo2_RevokeTaskInsteadExecutor : "TaskGo2_RevokeTaskInsteadExecutor",

    /// <summary>
    /// Đồng ý phê duyệt thay người ủy quyền
    /// </summary>
    TaskGo2_ApprovedTaskInsteadAssigner : "TaskGo2_ApprovedTaskInsteadAssigner",

    /// <summary>
    /// Từ chối phê duyệt thay người ủy quyền
    /// </summary>
    TaskGo2_DeniedTaskInsteadAssigner : "TaskGo2_DeniedTaskInsteadAssigner",
    /// <summary>
    /// Đánh dấu hoàn thành công việc
    /// </summary>
    TaskGo2_MarkDoneProcess : "TaskGo2_MarkDoneProcess",
    /// <summary>
    /// Đánh dấu hoàn thành công việc
    /// </summary>
    TaskGo2_MarkDoneProcessInsteadAssigner : "TaskGo2_MarkDoneProcessInsteadAssigner",

    /// <summary>
    /// Nhắc việc
    /// </summary>
    TaskGo2_RemindTask : "TaskGo2_RemindTask",

    /// <summary>
    /// Hủy phê duyệt công việc
    /// </summary>
    TaskGo2_CancelApproval : "TaskGo2_CancelApproval",

    /// <summary>
    /// Hủy phê duyệt công việc thay người giao việc
    /// </summary>
    TaskGo2_CancelApprovalInsteadAssigner : "TaskGo2_CancelApprovalInsteadAssigner",

    /// <summary>
    /// Hủy đánh dấu hoàn thành công việc
    /// </summary>
    TaskGo2_CancelDoneTask : "TaskGo2_CancelDoneTask",

    /// <summary>
    /// Hủy đánh dấu hoàn thành thay người giao việc
    /// </summary>
    TaskGo2_CancelDoneTaskInsteadAssigner : "TaskGo2_CancelDoneTaskInsteadAssigner",
    /// <summary>
    /// Thông báo cho người đi bàn giao công việc
    /// </summary>
    TaskGo2_TaskHandoverFromUser : "TaskGo2_TaskHandoverFromUser",
    /// <summary>
    /// Thông báo cho người nhận bàn giao công việc
    /// </summary>
    TaskGo2_TaskHandoverToUser : "TaskGo2_TaskHandoverToUser",
    /// Thông báo của hết hạn
    TaskGo2_NotifiLicence : "NotifiLicence",
  },
}
